import {
    PICKUP_DETAIL_CLOSE_NOTIFICATION,
    PICKUP_DETAIL_CLOSE_SAVE_NOTIFICATION,
    PICKUP_DETAIL_FORM_VALUE_CHANGE,
    PICKUP_DETAIL_OPEN_NOTIFICATION,
    SAVE_PICKUP_DETAIL_REQUEST_FAILED,
    SAVE_PICKUP_DETAIL_REQUEST_STARTED,
    SAVE_PICKUP_DETAIL_REQUEST_SUCCESS,
    VIEW_INVOICE_DETAIL_ADD_COMMENT,
    VIEW_INVOICE_DETAIL_ADD_LINE_IMAGE,
    VIEW_INVOICE_DETAIL_FAILED,
    VIEW_INVOICE_DETAIL_REMOVE_LINE_IMAGE,
    VIEW_INVOICE_DETAIL_REQUEST,
    VIEW_INVOICE_DETAIL_SUCCESS,
    VIEW_INVOICE_DETAIL_UPDATE_ALL_LINE_STATUS,
    VIEW_INVOICE_DETAIL_UPDATE_PICKUP_STATUS
} from "./InvoiceDetailConstants";


export const viewInvoiceDetailRequest = () => {
    return {
        type: VIEW_INVOICE_DETAIL_REQUEST
    }
}

export const viewInvoiceDetailSuccess = (invoice) => {
    return {
        type: VIEW_INVOICE_DETAIL_SUCCESS,
        payload: invoice
    }
}

export const viewInvoiceDetailFailed = () => {
    return {
        type: VIEW_INVOICE_DETAIL_FAILED
    }
}

export const addLineComment = (id, comment) => {

    return {
        type: VIEW_INVOICE_DETAIL_ADD_COMMENT,
        payload: {
            id,
            comment
        }
    }
}

export const addLineImage = (id, image) => {

    return {
        type: VIEW_INVOICE_DETAIL_ADD_LINE_IMAGE,
        payload: {
            id,
            image
        }
    }
}


export const removeLineImage = (id) => {

    return {
        type: VIEW_INVOICE_DETAIL_REMOVE_LINE_IMAGE,
        payload: {
            id
        }
    }
}

export const updatePickupStatus = (id, status) => {

    return {
        type: VIEW_INVOICE_DETAIL_UPDATE_PICKUP_STATUS,
        payload: {
            id,
            status
        }
    }
}


export const updateAllLineStatus = (checkedStatus) => {

    return {
        type: VIEW_INVOICE_DETAIL_UPDATE_ALL_LINE_STATUS,
        payload: {
            checkedStatus
        }
    }
}

export const savePickupDetailRequestStarted = () => {
    return {
        type: SAVE_PICKUP_DETAIL_REQUEST_STARTED
    }
}

export const savePickupDetailRequestSuccess = (message) => {
    return {
        type: SAVE_PICKUP_DETAIL_REQUEST_SUCCESS,
        payload: message
    }
}

export const savePickupDetailRequestFailed = (message) => {
    return {
        type: SAVE_PICKUP_DETAIL_REQUEST_FAILED,
        payload: message
    }
}

export const handleNotificationClose = () => {
    return {
        type: PICKUP_DETAIL_CLOSE_NOTIFICATION
    }
}


export const showNotification = (type, message) => {
    return {
        type: PICKUP_DETAIL_OPEN_NOTIFICATION,
        payload: {
            type,
            message
        }
    }
}

export const handlePickupInfoFormValueChange = (name, value) => {
    return {
        type: PICKUP_DETAIL_FORM_VALUE_CHANGE,
        payload: {
            name,
            value
        }
    }
}

export const closePickupSaveNotification = () => {
    return {
        type: PICKUP_DETAIL_CLOSE_SAVE_NOTIFICATION,

    }
}
